import { AfterContentInit, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService, LoginType } from 'src/app/shared/services/client.service';
import { AnalyticsService } from 'src/app/shared/util/analytics.service';
import { SeoService } from 'src/app/shared/util/seo.service';
import { SessionManager } from 'src/app/shared/util/session-manager';
import { SsrUtilService } from 'src/app/shared/util/ssr-util.service';
import { PAGE_TITLE } from 'src/globals';
import Swal from 'sweetalert2';

declare let gapi: any;
declare let FB: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterContentInit {
  fmGroup: UntypedFormGroup;
  redirectUrl: string = '/home';

  constructor(
    private sm: SessionManager,
    private titleService: Title,
    private seo: SeoService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private ga: AnalyticsService,
    private clientService: ClientService
  ) {
    this.createForm();
  }

  createForm() {
    this.fmGroup = this.formBuilder.group({
      email: [null, Validators.required, Validators.email],
      pwd: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.titleService.setTitle(`Login - ${PAGE_TITLE}`);

    // Adiciona/Atualiza as Tags ao head da pagina
    this.seo.addTitle(this.titleService.getTitle());

    // se logout
    this.route.data.subscribe(v => {
      if (v.logout) {
        this.sm.logout();
        this.router.navigateByUrl('/home');
      }
    });

    // se houver redirectUrl, usa
    this.route.queryParams.subscribe(params => {
      const { redirectUrl } = params;
      if (redirectUrl) this.redirectUrl = redirectUrl;
    });

    //
    this.attachScripts();
  }

  attachScripts() {
    // google signin
    (function (d, s, id) {
      var js,
        gjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://apis.google.com/js/platform.js?onload=gAsyncInit';
      js.async = true;
      js.defer = true;
      gjs.parentNode.insertBefore(js, gjs);
      console.debug('Google Sign-in added.');
    })(document, 'script', 'google-signin');

    // facebook signin
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      js.async = true;
      js.defer = true;
      fjs.parentNode.insertBefore(js, fjs);
      console.debug('Facebook Sign-in added.');
    })(document, 'script', 'facebook-jssdk');
  }

  ngAfterContentInit(): void {
    // google init
    (<any>window).gAsyncInit = function () {
      gapi.load('auth2', function () {
        gapi.auth2.init({
          client_id: '707342016905-geukam6snrubicc3sqoti76d2pmj5ev1.apps.googleusercontent.com',
          scope: 'email profile',
          // fetch_basic_profile: false
        });
        console.debug('Google-Auth initialized.');
      });
      console.debug('Google initialized.');
    };

    // facebook init
    (<any>window).fbAsyncInit = function () {
      FB.init({
        appId: '830775967506163',
        xfbml: true,
        version: 'v18.0',
      });
      FB.AppEvents.logPageView();
      console.debug('Facebook initialized.');
    };
  }

  onSend() {
    // Valida os campos do form
    if (this.fmGroup.invalid) return;

    const { email, pwd } = this.fmGroup.value;
    this.signIn(LoginType.Email, null, null, email, pwd);
  }

  signIn(type: LoginType, id: string, name: string, email: string, senha: string) {
    this.clientService.signIn(type, id, name, email, senha).subscribe(
      () => {
        this.ga.trackEvent(type.toString(), 'login', id || email);
        this.router.navigate(['/home'], { replaceUrl: true });
      },
      error => {
        SessionManager.handleHttpError(error, 'Falha ao realizar login');
      }
    );
  }

  onGoogleSignIn() {
    let _this = this;
    var auth2 = gapi.auth2.getAuthInstance();
    auth2.signIn().then(function () {
      console.debug('Google connected');

      if (auth2.isSignedIn.get()) {
        var profile = auth2.currentUser.get().getBasicProfile();
        _this.signIn(LoginType.Google, profile.getId(), profile.getName(), profile.getEmail(), null);
      }
    });
  }

  onFacebookSignIn() {
    let _this = this;
    FB.login(
      function (response) {
        if (response.status === 'connected') {
          console.debug('Facebook connected');
          FB.api('/me?fields=id,name,email', function (response) {
            _this.signIn(LoginType.Facebook, response.id, response.name, response.email, null);
          });
        } else console.debug('FB not logged');
      },
      { scope: 'public_profile,email' }
    );
  }

  // onForgotPassword() {
  //   Swal.fire({
  //     title: 'Esqueceu sua senha?',
  //     text: 'Digite o mesmo e-mail utilizado em seu cadastro.',
  //     input: 'text',
  //     showCancelButton: true,
  //     inputValidator: value => {
  //       return !value && 'Digite um e-mail!';
  //     },
  //     showLoaderOnConfirm: true,
  //     allowOutsideClick: () => !Swal.isLoading(),
  //     preConfirm: value => {
  //       return new Promise<boolean>((resolve, reject) => {
  //         this.clientService.recoveryPassword(value).subscribe(
  //           ({ message }) => {
  //             Swal.fire(message, 'Verifique a sua caixa de e-mail, inclusive a do SPAM.', 'success');
  //             resolve(true);
  //           },
  //           error => {
  //             // SessionManager.handleHttpError(error, 'Falha na autenticação');
  //             Swal.showValidationMessage(SessionManager.getHttpErrorMessage(error, 'Falha na autenticação.'));
  //             reject(false);
  //           }
  //         );
  //       }).catch(error => false);
  //     },
  //   });
  // }
}
